import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import * as typesAccount from '@account/store/types'
import PopupLayout from '@appbase/templates/PopupLayout/PopupLayout.vue'
import * as dateHelper from '@appbase/util/date-helper'
import api from '@home/api'
import * as dateutil from "@appbase/util/date-helper";

@Component({
    components: {
        PopupLayout
    },
    computed: mapGetters({
        user: typesAccount.USER,
        current: typesAccount.CURRENT,
    }),
})
export default class CleanDesk extends Vue {
    
    user!: account.User;
    current!: account.TCurrent;

    checkList: kyoboBook.cleandesk.CheckList[] = []
    
    years: number[] = []
    selectedYear: number = new Date().getFullYear()
    selectedMonth: number = new Date().getMonth()+1

    useDate: string = dateutil.uGetDateFormat('yyyyMM', new Date(`${this.selectedYear}-${this.selectedMonth}-01`))
    checkVal: { id: number, val: string }[] = []
    submitted: boolean = false
    isCLNDESKRole: boolean = false

    get period() {
        var date = new Date(`${this.useDate.replace(/(^[0-9]{4})([0-9]{2})/,'$1-$2')}-01`)
        var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
        return `${dateHelper.uGetDateFormat('yyyy.MM.dd', firstDay)} ~ ${dateHelper.uGetDateFormat('yyyy.MM.dd', lastDay)}`
    }

    get isPastMonth(){
        return this.useDate !== dateutil.uGetDateFormat('yyyyMM', new Date())
    }

    loadCheckList() {
        api.kyobobook.getCheckList(this.useDate).then(res => {
            this.checkList = res.list
            this.submitted = res.isSubmit || this.useDate !== dateutil.uGetDateFormat('yyyyMM', new Date())
            if(!res.checkValue || res.checkValue === '[]'){
                this.checkVal = this.checkList.map(c => {
                    return {
                        id: c.id,
                        val: ''
                    }
                })
            }
            else{
                var answer:{ id: number, val: string }[] = JSON.parse(res.checkValue)
                this.checkVal = answer.filter(a=>this.checkList.findIndex(c=>c.id === a.id)>=0)
                this.submitted = this.submitted && this.checkVal.every(c=>c.val!=='')
            }
        }).finally(()=>{
            this.$emit('status',this.submitted)
            this.checkRoleType()
        })
    }

    onSave() {
        if(this.submitted){
            (window as any).alertAsync(this.$t('이미_제출되었습니다'))
            return
        }
        
        var allChecked = this.checkVal?.every((c) => c.val !== '')
        if (!allChecked) {
            (window as any).alertAsync(this.$t('선택누락'))
            return
        }
        var checkVal = JSON.stringify(this.checkVal)
        api.kyobobook.submitCheckList(this.useDate,checkVal,this.user.personCode).then(res=>{
            if(res > 0){
                (window as any).alertAsync(this.$t('제출되었습니다'))
                this.loadCheckList()
            }
        })

    }

    onClickCheckVal(id: number, val: string) {
        var ft = this.checkVal?.filter(c => c.id === id)
        if (ft) {
            ft[0].val = val
        }
    }

    getCheckedVal(id: number){
        var lst = this.checkVal?.filter(c=> this.checkList.findIndex(f=>f.id === c.id)>=0)
        if(lst && lst.length>0){
                var ft = this.checkVal.filter(c=>c.id === id)
            if(ft){
                return ft[0].val
            }
        }
        return ''
    }

    onClickMonth(mon: number){
        this.selectedMonth = mon
        this.useDate = dateutil.uGetDateFormat('yyyyMM', new Date(`${this.selectedYear}-${this.selectedMonth}-01`))
    }

    goToCleandesk() {
        const routePath = `${window.location.origin}/admin/func/cleandesk/submission`
        window.close();
        window.open(routePath)
    }

    checkRoleType() {
        const roles = this.current.permissions.roles;
    
        for (let i = 0; i < roles.length; i++) {
            if (roles[i].roleType === 'ROOT' || roles[i].roleType === 'CLNDESK') {
                this.isCLNDESKRole = true;
                break;
            } else {
                this.isCLNDESKRole = false;
            }
        }
    }
    
    created() {
        for (var i = 0; i <= (new Date().getFullYear() - 2025)+1; i++) {
            this.years.push(2025 + i)
        }
        this.loadCheckList()
    }

    @Watch('selectedYear')
    onChangedSelectedYear(year: number){
        this.useDate = dateutil.uGetDateFormat('yyyyMM', new Date(`${this.selectedYear}-${this.selectedMonth}-01`))
    }

    @Watch('useDate')
    onChangedUseDate(date: string){
        if(this.isPastMonth)
            (window as any).alertAsync(this.$t('제출기간이_아닙니다'))
            
        this.loadCheckList()
    }
}
